var createStaticBgHelper = function(){
	return {
		render: function(){}
	};
};

module.exports = {
	create: function(){
		return createStaticBgHelper();
	}
};

